import React, { Component } from "react";
import Pencarian from "./pencarian-pt/Pencarian";
import PT from "../Dashboard/PT";
import Profile from "../Profile";
import StandarSpmi from "./Penetapan/StandarSpmi";
import StandarPerguruanTinggi from "./Penetapan/StandarPerguruanTinggi";
import MekanismePendokumentasian from "./Penetapan/MekanismePendokumentasian";
import Evaluasi from "./Evaluasi/Evaluasi";
import DashboardPelaksanaan from "./Pelaksanaan/DashboardPelaksanaan";
import PropTypes from 'prop-types';
import {AppBar, makeStyles, Tabs, Tab, Typography, Button} from '@material-ui/core';
import Pengendalian from "./Pengendalian/Pengendalian";
import Peningkatan from "./Peningkatan/Peningkatan";
import PedomanSiklus from "./Penetapan/PedomanSiklusPage";
import DampakTridharma from "../DampakTridharma/DampakTridharma";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

function ScrollableTabsButtonForce(params) {
  // const [value, setValue] = React.useState(0);
  const [value, setValue] = React.useState((localStorage.getItem('tab_actve') !== undefined) ? parseInt(localStorage.getItem('tab_actve')) : 0);
  function handleChange(event, newValue) {
    // let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    // if(sessiondata.i_idrole === 10 || sessiondata.i_idrole === 2013 ){
      localStorage.setItem("tab_actve",newValue);
    // }
    setValue(newValue);
  }
  
 function Pencarian(){
    localStorage.removeItem('tab_actve');
    localStorage.removeItem('id_sp_temp');
    localStorage.removeItem('nama_id');
    window.location.reload();
}

  return (

      <>
      <div className="row row-paddingless">
        <div className="col-md-12 text-right">
            <a href={`/search-pt`}  className="btn btn-primary">
                <i className="flaticon2-back"></i>
                Kembali Cari Perguruan Tinggi Lain
            </a>
        </div>
    </div><br/>
      <AppBar position="static" color="default" style={{marginBottom: "20px", boxShadow: "none", backgroundColor: "#ffffff"}}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="secondary"
          textColor="secondary"
        >
          <Tab label="Dashboard PT" />
          <Tab label="Profil PT" />
          <Tab label="Pengaturan Tentang Komitmen SPMI" />
          <Tab label="Standar Nasional Pendidikan Tinggi" />
          <Tab label="Standar Yang Ditetapkan Institusi" />
          <Tab label="Pedoman Siklus PPEPP" />
          <Tab label="Mekanisme Pendokumentasian" />
          <Tab label="Evaluasi" />
          <Tab label="Pengendalian" />
          <Tab label="Peningkatan" />
          <Tab label="Dampak Tridharma" />
        </Tabs>
      </AppBar>
      {value === 0 && <PT id_sp={params.id_sp}/>}
      {value === 1 && <Profile id_sp={params.id_sp}/>}
      {value === 2 && <StandarSpmi id_sp={params.id_sp}/>}
      {value === 3 && <DashboardPelaksanaan id_sp={params.id_sp}/>}
      {value === 4 && <StandarPerguruanTinggi id_sp={params.id_sp}/>}
      {value === 5 && <PedomanSiklus id_sp={params.id_sp}/>}
      {value === 6 && <MekanismePendokumentasian id_sp={params.id_sp}/>}
      {value === 7 && <Evaluasi id_sp={params.id_sp}/>}
      {value === 8 && <Pengendalian id_sp={params.id_sp}/>}
      {value === 9 && <Peningkatan id_sp={params.id_sp}/>}
      {value === 10 && <DampakTridharma id_sp={params.id_sp}/>}
    </>
  );
}
class DetailPTSPMI extends Component {
  
    render(){
        let id_sp_temp = this.props.match.params.id;
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let display = "";
        if(id_sp_temp !== undefined){
            if (sessiondata.id_sp_penugasan !== null){
              let data_sp = sessiondata.id_sp_penugasan;
              let validatePenugasan = data_sp.filter(function(data) {
                return data === id_sp_temp;
              });
              console.log("validatePenugasan", validatePenugasan);
              if(validatePenugasan.length > 0){
                display = <ScrollableTabsButtonForce id_sp={this.props.match.params.id}/>
              }else{
                if(sessiondata.i_idrole === 10){
                  display = <ScrollableTabsButtonForce id_sp={this.props.match.params.id}/>
                }else{
                  window.history.back();
                }
              }
            }else{
              display = <ScrollableTabsButtonForce id_sp={this.props.match.params.id}/>
            }
        }else{
            display = <Pencarian/>;
        }
        return(display);
    }
}
export default DetailPTSPMI;